import React from "react";
import "./FunctionalViewButton.css";
import { Link } from "react-router-dom";

function FunctionalViewButton(props) {
  const { className } = props;

  return (
    <Link to="/functional-view-1">
      <div className={`functional-view-button ${className || ""}`}>
        <div className="functional-view-text valign-text-middle">Functional View</div>
      </div>
    </Link>
  );
}

export default FunctionalViewButton; 